type Pixel = {
  network: string;
  value: string;

  /**
   * Limit the pixel to a specific language.
   */
  language?: string;
};

type RegistrationPixels = {
  [countryCode: string]: Pixel[];
};

// These are the pixels to be fired when a user registers
const registrationPixels: RegistrationPixels = {
  GBR: [
    {
      network: 'Affinetwork',
      value:
        '<img src="https://in.o18.click/p?o=789390&m=1612&t=i&auth_token=a9da3d8d49" width="0px" height="0px">',
    },
  ],
  IND: [
    {
      network: 'Affinetwork',
      value:
        '<img src="https://in.o18.click/p?o=1224412&m=1612&t=i&auth_token=a9da3d8d49" width="0px" height="0px">',
      language: 'hi',
    },
    {
      network: 'Affinetwork',
      value:
        '<img src="https://in.o18.click/p?o=19678958&m=1612&t=i&auth_token=a9da3d8d49" width="0px" height="0px">',
      language: 'bn',
    },
  ],
};

export default registrationPixels;
